export const formatString = (format, ...params) => {
    return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof params[number] !== 'undefined'
            ? params[number]
            : match;
    });
};
